/**
 * Zentrale Bildverwaltung für die Website.
 * Aktuell sind Platzhalter aus dem bestehenden Bildbestand hinterlegt.
 * Nach dem Fotoshooting: Pfade hier austauschen – alle Komponenten ziehen automatisch nach.
 *
 * FOTO-SHOOTING BRIEF (für den Fotografen):
 * ─────────────────────────────────────────
 * 1. hero          – Weitwinkel, Skyline + Wiese, goldene Stunde, Querformat 16:9
 * 2. experience.*  – 6 Motive für Bento-Grid (siehe einzelne brief-Felder)
 * 3. bannerSkyline – Panorama Skyline bei Sonnenuntergang, sehr breit (21:9)
 * 4. bannerNature  – Morgenstimmung auf dem Platz, Nebel/Licht, Querformat
 * 5. surroundings.*– 4 Umgebungs-Motive (Stadt, Main/Schiff, Bäcker/Markt, ÖPNV optional)
 * 6. openingHours  – Rezeption / Familie Borgstedt, herzlich & einladend
 * 7. contact       – Team-Foto oder Gäste an der Rezeption
 * 8. facilities.*  – je Tab ein Hauptmotiv (5 Bilder)
 * 9. gallery       – 20–30 weitere Stimmungsbilder (Platz, Gäste, Details, Jahreszeiten)
 */

export interface SiteImage {
  src: string;
  alt: string;
  /** Kurzbeschreibung für den Fotografen */
  brief: string;
}

export const siteImages = {
  hero: {
    src: "/images/IMG_0930.jpg",
    alt: "Wohnmobil am Main mit Blick auf die Frankfurter Skyline",
    brief: "Hero: Stellplatz am Main, Skyline im Hintergrund",
  },
  experience: {
    skyline: {
      src: "/images/IMG_0930.jpg",
      alt: "Frankfurter Skyline vom Stellplatz am Main",
      brief: "Skyline-Blick vom Platz",
    },
    meadow: {
      src: "/images/IMG_0888.jpg",
      alt: "Stellplätze unter Bäumen auf der Wiese",
      brief: "Wiesengelände mit Wohnwagen und Bäumen",
    },
    family: {
      src: "/images/IMG_0928.jpg",
      alt: "Weg über die Wiese am Campingplatz",
      brief: "Gäste auf dem Weg über den Platz",
    },
    playground: {
      src: "/images/IMG_0904.jpg",
      alt: "Spielplatz und Tischtennis auf der Wiese",
      brief: "Spielplatz mit Rutsche, Schaukel und Tischtennis",
    },
    mainRiver: {
      src: "/images/IMG_7603.jpg",
      alt: "Aufenthaltsraum mit Blick auf den Main",
      brief: "Sitzecke im Aufenthaltsraum, Fenster zum Fluss",
    },
    evening: {
      src: "/images/IMG_0920-scaled.jpg",
      alt: "Zelt und Wohnmobil direkt am Main",
      brief: "Ruhiger Stellplatz am Fluss",
    },
  },
  banners: {
    skyline: {
      src: "/images/IMG_0930.jpg",
      alt: "Skyline von Frankfurt vom Campingplatz Mainkur",
      brief: "Skyline-Panorama vom Platz",
    },
    nature: {
      src: "/images/IMG_0888.jpg",
      alt: "Wiese und Stellplätze auf dem Campingplatz",
      brief: "Wiese, Bäume, Stellplätze",
    },
  },
  surroundings: {
    frankfurt: {
      src: "/images/IMG_0930.jpg",
      alt: "Blick vom Campingplatz auf die Frankfurter Skyline",
      brief: "Skyline, vom Platz aus sichtbar",
    },
    transport: {
      src: "/images/IMG_0928.jpg",
      alt: "Weg vom Platz in Richtung Maintal",
      brief: "Weg über den Platz, Anbindung in der Nähe",
    },
    bakery: {
      src: "/images/IMG_0867.jpg",
      alt: "Kiosk mit Getränken und Snacks",
      brief: "Kiosk auf dem Platz",
    },
    mainShip: {
      src: "/images/IMG_0920-scaled.jpg",
      alt: "Der Main direkt am Campingplatz",
      brief: "Flussufer am Platz",
    },
  },
  openingHours: {
    src: "/images/IMG_0885-scaled.jpg",
    alt: "Sanitär- und Wirtschaftsgebäude auf dem Platz",
    brief: "Gebäude mit Sanitär und Rezeption",
  },
  contact: {
    src: "/images/IMG_7618.jpg",
    alt: "Sitzecke im Aufenthaltsraum mit Blick auf den Main",
    brief: "Aufenthaltsraum, einladend",
  },
  directions: {
    src: "/images/IMG_0885-scaled.jpg",
    alt: "Gebäude an der Zufahrt zum Campingplatz",
    brief: "Gebäude, das Gäste bei der Anfahrt sehen",
  },
  pitches: {
    standard: {
      src: "/images/IMG_0888.jpg",
      alt: "Stellplatz auf der Wiese",
      brief: "Wiesenstellplatz mit Bäumen",
    },
    komfort: {
      src: "/images/IMG_0928.jpg",
      alt: "Stellplätze entlang des Weges",
      brief: "Stellplätze am Weg",
    },
    premium: {
      src: "/images/IMG_0930.jpg",
      alt: "Stellplatz mit Blick auf Main und Skyline",
      brief: "Stellplatz am Main mit Skyline",
    },
  },
} as const;
